// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3OX_e","amount":"Amount_amount__1zAgz","tip":"Amount_tip__2EyAz","tipHeader":"Amount_tipHeader__2Ma_U","tipsWrap":"Amount_tipsWrap__2J9DU"};